/**
 * @fileoverview Fetch adapter for HttpClientPort.
 *
 * Owns exactly two things the API client used to own itself: the origin every
 * request goes to, and attaching the bearer token. Both now arrive by
 * injection, so retargeting an environment is a wiring change and the client
 * above can be exercised against a fake without a network.
 */

import type { HttpClientPort, HttpRequest, TokenProvider } from "../ports/http.js";

export class FetchHttpClient implements HttpClientPort {
  readonly baseUrl: string;
  private readonly token: TokenProvider;

  constructor(baseUrl: string, token: TokenProvider) {
    // Normalized here as well as in parseAppConfig so the invariant holds even
    // when this adapter is constructed directly in a test.
    this.baseUrl = baseUrl.replace(/\/+$/, "");
    this.token = token;
  }

  async send({ path, method = "GET", body, headers, signal }: HttpRequest): Promise<Response> {
    const url = `${this.baseUrl}/${path.replace(/^\/+/, "")}`;
    const bearer = this.token();

    return fetch(url, {
      method,
      signal,
      headers: {
        ...(body === undefined ? {} : { "Content-Type": "application/json" }),
        ...(bearer ? { Authorization: `Bearer ${bearer}` } : {}),
        ...headers,
      },
      ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    });
  }
}
